export default {
    navigationBarTitleText: '3D 预览',
};
